// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statistics .shuaxinImg[data-v-1370df76]{cursor:pointer;margin-right:5px}.statistics .title[data-v-1370df76]{font-size:12px}.statistics img[data-v-1370df76]{position:relative;top:-1px}", ""]);
// Exports
module.exports = exports;
